import React from 'react';

import useGetRequest from 'src/hooks/useGetRequest';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import Card from 'src/components/Card';
import { RoleAssignment } from 'src/types';
import UserCell from '../../components/cells/UserCell';
import RoleAssignmentsForm from '../AdminExperience/Engagements/ViewEngagement/Settings/RoleAssignmentsForm';
import Button from '../../components/Button';

interface Props {
  engagementId: string,
  workflowId: string,
}

function RoleAssignmentsCard({ engagementId, workflowId }: Props) {
  const [editMode, setEditMode] = React.useState(false);
  const { result: roleAssignments }: { result: RoleAssignment[] } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/role-assignments/`,
    initialResult: [],
  });

  const editButton = (
    <Button look="primary" onClick={() => setEditMode(true)}>
      Edit
    </Button>
  );

  if (editMode) {
    return (
      <RoleAssignmentsForm
        engagementId={engagementId}
        workflowId={workflowId}
        submitMethodOverride="patch"
        cancelEdit={() => setEditMode(false)}
      />
    );
  }

  return (
    <Card title="Role assignments" action={editButton}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              Role
            </TableCell>
            <TableCell>
              User
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
              roleAssignments.map((ra) => (
                <TableRow>
                  <TableCell>{ra.role.name}</TableCell>
                  <TableCell>
                    <UserCell accounts={[ra.account]} />
                  </TableCell>
                </TableRow>
              ))
            }
        </TableBody>
      </Table>
    </Card>
  );
}

export default RoleAssignmentsCard;
